"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _refType = _interopRequireDefault(require("@mui/utils/refType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _NotchedOutline = _interopRequireDefault(require("./NotchedOutline"));
var _useFormControl = _interopRequireDefault(require("../FormControl/useFormControl"));
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _outlinedInputClasses = _interopRequireWildcard(require("./outlinedInputClasses"));
var _InputBase = _interopRequireWildcard(require("../InputBase/InputBase"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    var composedClasses = (0, _composeClasses.default)(slots, _outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var OutlinedInputRoot = (0, _zeroStyled.styled)(_InputBase.InputBaseRoot, {
    shouldForwardProp: function(prop) {
        return (0, _rootShouldForwardProp.default)(prop) || prop === 'classes';
    },
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: _InputBase.rootOverridesResolver
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    var _obj, _obj1;
    return _obj1 = {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, _define_property(_obj1, "&:hover .".concat(_outlinedInputClasses.default.notchedOutline), {
        borderColor: (theme.vars || theme).palette.text.primary
    }), // Reset on touch devices, it doesn't add specificity
    _define_property(_obj1, '@media (hover: none)', _define_property({}, "&:hover .".concat(_outlinedInputClasses.default.notchedOutline), {
        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
    })), _define_property(_obj1, "&.".concat(_outlinedInputClasses.default.focused, " .").concat(_outlinedInputClasses.default.notchedOutline), {
        borderWidth: 2
    }), _define_property(_obj1, "variants", _to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(function(param) {
        var _param = _sliced_to_array(param, 1), color = _param[0];
        return {
            props: {
                color: color
            },
            style: _define_property({}, "&.".concat(_outlinedInputClasses.default.focused, " .").concat(_outlinedInputClasses.default.notchedOutline), {
                borderColor: (theme.vars || theme).palette[color].main
            })
        };
    })).concat([
        {
            props: {},
            // to overide the above style
            style: (_obj = {}, _define_property(_obj, "&.".concat(_outlinedInputClasses.default.error, " .").concat(_outlinedInputClasses.default.notchedOutline), {
                borderColor: (theme.vars || theme).palette.error.main
            }), _define_property(_obj, "&.".concat(_outlinedInputClasses.default.disabled, " .").concat(_outlinedInputClasses.default.notchedOutline), {
                borderColor: (theme.vars || theme).palette.action.disabled
            }), _obj)
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.startAdornment;
            },
            style: {
                paddingLeft: 14
            }
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.endAdornment;
            },
            style: {
                paddingRight: 14
            }
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.multiline;
            },
            style: {
                padding: '16.5px 14px'
            }
        },
        {
            props: function(param) {
                var ownerState = param.ownerState, size = param.size;
                return ownerState.multiline && size === 'small';
            },
            style: {
                padding: '8.5px 14px'
            }
        }
    ])), _obj1;
}));
var NotchedOutlineRoot = (0, _zeroStyled.styled)(_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: function(props, styles) {
        return styles.notchedOutline;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
    };
}));
var OutlinedInputInput = (0, _zeroStyled.styled)(_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: _InputBase.inputOverridesResolver
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _object_spread_props(_object_spread({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && _define_property({
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        }
    }, theme.getColorSchemeSelector('dark'), {
        '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #266798 inset',
            WebkitTextFillColor: '#fff',
            caretColor: '#fff'
        }
    })), {
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.multiline;
                },
                style: {
                    padding: 0
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.startAdornment;
                },
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.endAdornment;
                },
                style: {
                    paddingRight: 0
                }
            }
        ]
    });
}));
var OutlinedInput = /*#__PURE__*/ React.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    var _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_inputComponent = props.inputComponent, inputComponent = _props_inputComponent === void 0 ? 'input' : _props_inputComponent, label = props.label, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, notched = props.notched, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_type = props.type, type = _props_type === void 0 ? 'text' : _props_type, other = _object_without_properties(props, [
        "components",
        "fullWidth",
        "inputComponent",
        "label",
        "multiline",
        "notched",
        "slots",
        "type"
    ]);
    var classes = useUtilityClasses(props);
    var muiFormControl = (0, _useFormControl.default)();
    var fcs = (0, _formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    var _slots_root, _ref;
    var RootSlot = (_ref = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : OutlinedInputRoot;
    var _slots_input, _ref1;
    var InputSlot = (_ref1 = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : components.Input) !== null && _ref1 !== void 0 ? _ref1 : OutlinedInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, _object_spread_props(_object_spread({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: function(state) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other), {
        classes: _object_spread_props(_object_spread({}, classes), {
            notchedOutline: null
        })
    }));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: _propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: _propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: _propTypes.default.shape({
        Input: _propTypes.default.elementType,
        Root: _propTypes.default.elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: _propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: _propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: _propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: _propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: _propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: _propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: _propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: _propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: _propTypes.default.node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: _propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: _propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: _propTypes.default.string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: _propTypes.default.bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: _propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: _propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: _propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: _propTypes.default.shape({
        input: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: _propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: _propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: _propTypes.default.any
} : void 0;
OutlinedInput.muiName = 'Input';
var _default = exports.default = OutlinedInput;
